import { useState } from 'react';

const AnimationSwitcher = ({component1, component2, text}) => {
    const [showFirstAnimation, setShowFirstAnimation] = useState(true);

    return (
        <div>
            <div className={`switcher ${!showFirstAnimation ? 'success' : ''}`}>
                <p className="switcher__text">{text}</p>
                <button className="switcher__btn"
                    onClick={() => setShowFirstAnimation(!showFirstAnimation)}
                >
                <span
                        className="switcher__thumb"
                        style={{
                            transform: showFirstAnimation
                                ? 'translateX(0)'
                                : 'translateX(19px)',
                            transition: 'transform 0.3s ease'
                        }}
                    />
                </button>
            </div>

            <div>
                { showFirstAnimation ? component1 : component2 }
            </div>
        </div>
    );
};

export default AnimationSwitcher;
